import axios from 'axios';
import myAxios from './myAxios';

export async function createContent(data, onProgress, abortController) {
  return myAxios.post('/content/content/', data, {
    signal: abortController.signal,
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: e => {
      onProgress(Math.floor((e.loaded / e.total) * 100));
    },
  });
}

export async function getContents(searchConfig) {
  return myAxios.get('/content/content/', { params: searchConfig });
}

export async function getContent(id) {
  return myAxios.get(`/content/content/${id}/`);
}

export async function deleteContent(id) {
  return myAxios.delete(`/content/content/${id}/`);
}

export async function updateContent(id, data) {
  return myAxios.patch(`/content/content/${id}/`, data);
}

export function createComment({ comment, content }) {
  return myAxios.post('/content/comment/', { comment, content });
}

export function getComments({ contentId }) {
  const params = {};
  if (contentId) params.content = contentId;
  return myAxios.get('/content/comment', { params });
}

export function deleteComment({ commentId }) {
  return myAxios.delete(`/content/comment/${commentId}/`);
}

export function addInteraction({ contentId, interaction }) {
  return myAxios.post('/content/content_interaction/', {
    content: contentId,
    type: interaction,
  });
}

export function deleteInteraction({ contentId, interaction }) {
  const data = {
    content: contentId,
    type: interaction,
  };
  return myAxios.post('/content/content_interaction/delete/', data);
}

export function downloadFile(url, onProgress) {
  return axios.get(url, {
    responseType: 'blob',
    onDownloadProgress: e => {
      onProgress(Math.floor((e.loaded / e.total) * 100));
    },
  });
}

export function getContentAnalytics(id) {
  return myAxios.get(`/content/content/${id}/analytics/`);
}

export function getContentEvaluationReport(id) {
  return myAxios.get(`/content/content/${id}/evaluators/`);
}

export function getContentEvaluationUserResponse(id) {
  return myAxios.get(`/content-evaluation/responses/?content=${id}`);
}

export function getQuestionList() {
  return myAxios.get('/content-evaluation/questions/');
}

export function createResponse({ content, question, response }) {
  return myAxios.post('/content-evaluation/responses/', {
    content,
    question,
    response,
  });
}

export function getContentInteractions({ contentId, interactionType }) {
  return myAxios.get(
    `/content/content/${contentId}/interactions/?type=${interactionType}`,
  );
}

export function updateContentElection({ contentId, elected }) {
  return myAxios.patch(`/content/content/${contentId}/elect/`, { elected });
}

export function updateContentEvaluation({ contentId, evaluation_requested }) {
  return myAxios.patch(`/content/content/${contentId}/request-evaluation/`, {
    evaluation_requested,
  });
}

export function createInteractionRequest({
  contentId,
  url,
  followRequest,
  likeRequest,
  commentRequest,
}) {
  return myAxios.post(`/content/content/${contentId}/interaction-request/`, {
    url,
    content_id: contentId,
    follow_request: followRequest,
    like_request: likeRequest,
    comment_request: commentRequest,
  });
}

export function deleteInteractionRequest(contentId, requestId) {
  return myAxios.delete(
    `/content/content/${contentId}/interaction-request/${requestId}`,
  );
}

export function createInteractionResponse({
  interactionRequestId,
  interactionType,
  note = '',
}) {
  return myAxios.post('/content/interaction-responses/', {
    interaction_request: interactionRequestId,
    interaction_type: interactionType,
    note,
  });
}

export function updateInteractionResponse({ interactionResponseId, note }) {
  return myAxios.patch(
    `/content/interaction-responses/${interactionResponseId}/`,
    {
      note,
    },
  );
}

export function getContentSupportInfo({ contentId, interactionType }) {
  return myAxios.get(
    `/content/interaction-responses/?interaction_type=${interactionType}&interaction_request__content=${contentId}`,
  );
}
